import type { DetailPanelInfo } from '../../contexts/PanelContext';
import type { ProjectMember, WorkflowStatusInfo } from '../../services/projectService';
import type { TestCaseListItem } from '../../services/testCaseService';
import IssueDetailPanel from '../issue/IssueDetailPanel';
import RequirementDetailPanel from '../requirement/RequirementDetailPanel';
import TCDetailPanel from '../testcase/TCDetailPanel';

interface DetailPanelRouterProps {
  detailPanel: DetailPanelInfo;
  projectId: string;
  projectKey?: string;
  members: ProjectMember[];
  workflowStatuses?: WorkflowStatusInfo[];
  projectWorkflow?: { workflowId: string; name: string; statuses: WorkflowStatusInfo[] };
  onClose: () => void;
}

export default function DetailPanelRouter({
  detailPanel,
  projectId,
  projectKey,
  members,
  workflowStatuses,
  projectWorkflow,
  onClose,
}: DetailPanelRouterProps) {
  switch (detailPanel.type) {
    case 'issue':
      return (
        <>
          <div className="fixed inset-0 bg-black/20 z-30" onClick={onClose} />
          <IssueDetailPanel
            projectId={projectId}
            projectKey={projectKey}
            issueId={detailPanel.itemId}
            onClose={onClose}
            members={members}
            workflowStatuses={workflowStatuses}
            projectWorkflow={projectWorkflow}
          />
        </>
      );

    case 'requirement':
      return (
        <RequirementDetailPanel
          requirementId={detailPanel.itemId}
          projectId={projectId}
          isOpen
          onClose={onClose}
          members={members}
        />
      );

    case 'testcase':
      if (!detailPanel.metadata) return null;
      return (
        <TCDetailPanel
          testCase={detailPanel.metadata as TestCaseListItem}
          projectId={projectId}
          onClose={onClose}
        />
      );

    case 'spec':
      // 추후 SpecDetailPanel 구현 시 추가
      return null;

    default:
      return null;
  }
}
